import { IDefaultStageSettings } from "oc-threejs/DefaultStageSettings";

export interface IUndoSettings {
  enabled: boolean;
  max: number;
}

export interface ISnapshotDefinition {
  table?: string;
  uploadPath?: string;
  direction?: { x: number; y: number; z: number };
  object?: { x: number; y: number; z: number };
  zoomTo?: boolean;
  hideObjectsByName?: string[];
  extraZoom?: number;
  renderWidth?: number;
  renderHeight?: number;
  backgroundColor?: number;
  backgroundAlpha?: number;
  filename?: string;
  filenamePrefix?: string;
  filenamePostfix?: string;
  filenameSuffix?: string;
  cameraDirection?: { x: number; y: number; z: number };
}

export interface IDefaultAppSettings {
  homeUrl: string;
  siteUrl: string;
  configuratorUrl: string;
  pleaseWaitFacebookUrl: string;
  pleaseWaitPinterestUrl: string;
  wkfgBackendUrl: string;
  wkfgContentBaseUrl: string;
  pdfUrl: string;
  userRole: "admin" | "kunde_eingeloggt" | "kunde_nicht_eingeloggt";
  userId: number | null;
  userGuid: string | null;
  priceFromServer: boolean;
  undo: IUndoSettings;
  autosaveAndRestore: boolean;
  stage: Partial<IDefaultStageSettings>;
  snapshotDefinitions: ISnapshotDefinition[];
}

/**
 * Die Default-Werte für die App-Settings. Die Stage ist Teil der App-Settings
 */
export const DefaultAppSettings: IDefaultAppSettings = {
  // die Landing bzw. Homepage, z.B. http://wirtschaftswunder/home/
  homeUrl: "",
  // die Base-Url der Konfigurator-Seiten, z.B. http://wirtschaftswunder/
  siteUrl: "",
  // die Url der Konfigurator-Seite, z.B. http://wirtschaftswunder/konfigurator/
  configuratorUrl: "",
  // die Url, unter der eine Bitte-Warten-Seite angezeigt wird, während die Konfiguration für Facebook gespeichert wird
  pleaseWaitFacebookUrl: "/bitte-warten-facebook",
  // die Url, unter der eine Bitte-Warten-Seite angezeigt wird, während die Konfiguration für Pinterest gespeichert wird
  pleaseWaitPinterestUrl: "/bitte-warten-pinterest",
  // die Url des Backends, z.B. http://wirtschaftswunder/wp-content/plugins/wkfg/laravel/public/jsonapi/
  wkfgBackendUrl: "",
  // die Basis-Url der Konfigurations-Bilder, Produkt-Thumbnails, Texturen und 3D-Modelle,
  // z.B. http://wirtschaftswunder/wp-content/upload/wkfgcontent
  wkfgContentBaseUrl: "",
  // die Basis-Url der PDF-API, z.B. http://wirtschaftswunder/wp-content/plugins/wkfg/laravel/public/mypdf/
  pdfUrl: "",

  // userRole kann sein 'admin', 'kunde_eingeloggt', 'kunde_nicht_eingeloggt'
  userRole: "kunde_nicht_eingeloggt",
  userId: null,
  userGuid: null,
  priceFromServer: false,

  // Configuration-Undo-Feature
  undo: {
    // ist das Feature eingeschaltet?
    enabled: false,
    // wie viele Configurationen können rückgängig gemacht werden?
    max: 20,
  },

  // setzt das Autosave-Feature aktiv, d.h. sollte eine veränderte Konfiguration ungespeichert sein,
  // dann wird der Benutzer beim nächsten Öffnen des Konfigurators gefragt,
  // ob er die ungespeicherte Konfiguration weiter bearbeiten möchte. Basiert auf localStorage.
  autosaveAndRestore: false,

  // siehe oc-threejs/DefaultStageSettings.js
  stage: {},

  snapshotDefinitions: [
    {
      // new
      table: "Model",
      uploadPath: "_thumbnails/Model/{Key}.jpg",

      direction: { x: 0, y: 0.2, z: 1 },
      object: { x: 0, y: 0, z: 0 },
      zoomTo: true,

      hideObjectsByName: ["ground", "coordinateOffset"],

      extraZoom: 1,

      renderWidth: 400,
      renderHeight: 400,
      backgroundColor: 0xffffff,
      backgroundAlpha: 0,

      // // old
      // filename: 'image',
      // filenamePrefix: '',
      // filenamePostfix: '',
      // filenameSuffix: '.jpg',
    },
    // todo Konfiguration wird noch nicht über snapshotDefinitions erreicht
    // {
    //     table: 'Konfiguration',
    //     filename: 'image',
    //     filenamePrefix: '',
    //     filenamePostfix: '',
    //     filenameSuffix: '.jpg',
    //     cameraDirection: {x:0, y:1.8, z:3},
    //     extraZoom: 1,
    //     renderWidth: 400,
    //     renderHeight: 400,
    //     backgroundColor: 0xFFFFFF,
    //     backgroundAlpha: 1,
    // },
  ],
};
